import { makeStyles } from '@material-ui/core'
import { Button } from '@mui/material'
import { useState } from 'react'
import Modal from 'src/components/common/Modal'
import RenewUploadModal from 'src/components/common/RenewPolicy/RenewUploadModal'

const RenewModal = ({ closeRenewModal, policyDetails, handleClick }) => {
  const classes = useStyles()
  const [showUploadModal, setShowUploadModal] = useState(false)

  const handleUploadModal = () => {
    setShowUploadModal(true)
  }

  const closeUploadModal = () => {
    setShowUploadModal(false)
    closeRenewModal()
  }

  return (
    <>
      {showUploadModal ? (
        <Modal
          id='modal'
          bgcolor={'#FFF'}
          ordered={showUploadModal}
          width={'100%'}
          left={'0%'}
          top={'0%'}
          borderRadius={'10px'}
          modelClosed={closeUploadModal}
        >
          <RenewUploadModal
            policyDetails={policyDetails}
            closeUploadModal={closeUploadModal}
          />
        </Modal>
      ) : null}
      <div className={classes.mainContainer}>
        <div className={classes.renewNowContainer}>
          <Button
            onClick={handleClick}
            size='small'
            variant='contained'
            className={classes.buyPolicyButton}
          >
            Buy Policy
          </Button>
        </div>
        <div className={classes.textContainer}>
          <div>
            <span>Or</span>
          </div>
          <div>
            <span>If Already Purchased</span>
          </div>
        </div>
        <div className={classes.renewalPolicyContainer}>
          <Button
            onClick={handleUploadModal}
            size='small'
            variant='contained'
            className={classes.renewalPolicyButton}
          >
            Upload Renewed Policy
          </Button>
        </div>
      </div>
    </>
  )
}

export default RenewModal
const useStyles = makeStyles({
  mainContainer: {
    margin: '20px',
    padding: '20px',
    textAlign: 'center',
  },
  textContainer: {
    padding: '10px 0px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  buyPolicyButton: {
    fontSize: '17px !important',
    fontWeight: '400 !important',
    lineHeight: '22px !important',
    fontFamily: 'roboto !important',
    background: '#B92250 !important',
    textTransform: 'capitalize !important',
    padding: '6px 75px !important',
    borderRadius: '10px !important',
  },
  renewalPolicyButton: {
    fontSize: '17px !important',
    fontWeight: '400 !important',
    lineHeight: '22px !important',
    fontFamily: 'roboto !important',
    background: '#B92250 !important',
    textTransform: 'capitalize !important',
    padding: '6px 25px !important',
    borderRadius: '10px !important',
  },
})
